<template>
  <material-chart-card
    color="green"
    elevation="0"
    type="Line"
    :data="chartData"
    :options="chartOptions"
  >
    <template slot="actions">
      <p
        class="category d-inline-flex font-weight-light mr-2"
      >Dzienna liczba utworzonych kont partnerów</p>
    </template>
  </material-chart-card>
</template>

<script>
import moment from 'moment';
import { mapState } from 'vuex';

import MaterialChartCard from '@/components/material/ChartCard';

// @vuese
// Wykres z liczbą utworzonych partnerów
// @group Chart
export default {
  components: { MaterialChartCard },
  props: {
    // opcje wykresu
    chartOptions: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      options: {
        lineSmooth: this.$chartist.Interpolation.cardinal({
          tension: 0
        }),
        low: 0,
        high: 50,
        chartPadding: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0
        },
        ...this.chartOptions
      }
    };
  },
  computed: mapState({
    chartData: state => {
      const stat = state.stats.partnersCreated;
      return {
        labels: Object.keys(stat).map(date => moment(date).format('MM-DD')),
        series: [Object.values(stat)]
      };
    }
  })
};
</script>
